<template>
  <div class="sky-tool-list-page">
    <div class="tool-page-content">
      <div class="tool-page-toolbar">
        <el-input
          placeholder="请输入工具名称、用途、场景等信息搜索"
          class="toolbar-input"
          size="medium"
          v-model="searchKeyword"
          @blur="searchReq"
          @change="searchReq"
        >
          <span slot="suffix" class="el-input__suffix"
            ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
          </span>
        </el-input>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick()">
        <el-tab-pane :label="item.label" :name="item.value" v-for="(item, tableIndex) in tabArr" :key="item.value">
          <div class="wsp-display-flex tool-list-content">
            <div v-for="item in toolInfoItem" :key="item.toolName" class="tool-item">
              <el-card>
                <div class="card-content">
                  <div class="tool-item-icon wsp-tool-dow-btn-center">
                    <img v-show="item.loadingEnd" :src="item.logoBase64Data" style="width: 58px; height: 58px;" />
                    <img
                      v-show="!item.loadingEnd"
                      src="../../assets/images/hanlin.png"
                      style="width: 58px; height: 58px;"
                    />
                  </div>
                  <div class="tool-item-description" :ref="item.id + '-heder-parent'">
                    <el-tooltip placement="top" :disabled="isShowTooltipHeader">
                      <div slot="content">
                        <div>
                          {{ item.toolDesc }}
                        </div>
                      </div>
                      <div
                        :ref="item.id + '-heder'"
                        class="card-header wsp-tool-app-description-1-line-hidder "
                        @mouseover="checkContentHeaderOverflow(item.id, tableIndex)"
                      >
                        {{ item.toolDesc }}
                      </div>
                    </el-tooltip>

                    <div>
                      <el-tooltip placement="top">
                        <div slot="content">
                          <div class="card-text ">
                            <span class="card-content-label">用途</span>： {{ item.toolDetail }}
                          </div>
                          <div class="card-text">
                            <span class="card-content-label">场景</span>： {{ item.toolScene }}
                          </div>
                        </div>
                        <div class="card-text  yyyy">
                          <div class="xXXXX">
                            <div :ref="item.id + '-yt-parent'">
                              <div
                                :ref="item.id + '-yt'"
                                class="wsp-tool-app-description-2-line-hidder"
                                @mouseover="checkContentOverflow(item.id, tableIndex)"
                              >
                                <span class="card-content-label">用途</span>： {{ item.toolDetail }}
                              </div>
                            </div>
                            <div :ref="item.id + '-cj-parent'">
                              <div :ref="item.id + '-cj'" class="wsp-tool-app-description-2-line-hidder">
                                <span class="card-content-label">场景</span>：{{ item.toolScene }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div :ref="item.id" class="card-text" @mouseover="checkContentOverflow(item.id, tableIndex)">
                          场景： {{ item.toolScene }}
                        </div> -->
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="wsp-tool-dow-btn wsp-tool-dow-btn-center">
                  <el-button round size="small" type="text" @click="openUrl(item.toolGuide)" v-if="item.toolGuide">
                    使用指南
                  </el-button>
                  <el-button round size="small" type="text" @click="openUrl(item.toolFaq)" v-if="item.toolFaq">
                    常见问题
                  </el-button>
                  <el-button round size="small" type="text" @click="toolDownload(item)">
                    下载
                  </el-button>
                </div>
              </el-card>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { Card, Row, Col, Button, Tabs, TabPane, Input, Tooltip } from 'element-ui'
import { action } from 'sky-engine/api/index'

import { TOOL } from '@/api/apiModules'
import { createNps, findNeedNps } from '@/api/nps'
import { getToolUrl, getToolLogo } from '@/api/tool'

import FeedbackDialog from '@/components/FeedbackDialog'
export default {
  name: 'tool',
  components: {
    [Card.name]: Card,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [Input.name]: Input,
    [TabPane.name]: TabPane,
    [Tooltip.name]: Tooltip
  },
  data() {
    return {
      toolInfo: [],
      toolInfoItem: [],
      activeName: 'all',
      isShowTooltip: true,
      isShowTooltipHeader: true,
      tabMap: {},
      tabArr: [
        {
          label: '全部',
          value: 'all'
        },
        {
          label: '售前测试',
          value: 'POC'
        },
        {
          label: '交付部署',
          value: 'PSC'
        },
        {
          label: '客户运营',
          value: 'OPERATION'
        },
        {
          label: 'Halo工具商店',
          value: 'HALO'
        },
        {
          label: '其它工具',
          value: 'OTHERS'
        }
      ],
      imageObj: {},
      searchKeyword: null
    }
  },
  computed: {
    toolArr() {
      var infoSize = Math.ceil(this.toolInfo.length / 3)
      var infoArr = []
      for (let index = 0; index < infoSize; index++) {
        infoArr.push(index)
      }
      return infoArr
    }
  },
  mounted() {
    this.getTools(this.activeName)
  },
  methods: {
    checkContentOverflow(id, index) {
      // const contentWrapperPa = this.$refs[id + '-yt-parent'][index]
      const contentWrapper = this.$refs[id + '-cj'][index]
      var aa = contentWrapper.scrollHeight > contentWrapper.clientHeight
      this.isShowTooltip = !aa
    },
    checkContentHeaderOverflow(id, index) {
      const contentWrapperPa = this.$refs[id + '-heder-parent'][index]
      const contentWrapper = this.$refs[id + '-heder'][index]

      var aa = contentWrapper.scrollWidth > contentWrapperPa.clientWidth
      this.isShowTooltipHeader = !aa
    },
    getTools(toolCategory) {
      const params = {
        page: 0,
        limit: 100,
        matchArr: [],
        sortArr: [{ fieldName: 'updateTime', direction: 'DESC' }]
      }
      if (toolCategory !== 'all') {
        params.matchArr.push({
          type: 'FUZZY',
          fieldNameArr: ['toolCategory'],
          value: toolCategory,
          matchRule: 'FULL'
        })
      }
      action(TOOL, 'listForWSP', params).then(res => {
        var temp = res.data.content.itemArr
        if (temp && temp.length > 0) {
          for (let index = 0; index < temp.length; index++) {
            const element = temp[index]
            element.loadingEnd = false
            element.logoBase64Data = null
            this.fetchToolLogo(element.id, index)
          }
        }
        this.toolInfo = temp
        this.toolInfoItem = temp
      })
    },
    toolDownload(item) {
      const _this = this
      if (item.id) {
        //二次下载并且经过一段时间后进行填写反馈
        const params = { toolId: item.id }
        findNeedNps(params).then(res => {
          const nps = res.data.content
          if (nps.toolId) {
            var title = '问题反馈与建议'
            var dialog = this.$root.$dialog({
              template: h => {
                const feedback = params
                const isModel = true
                const sourceFrom = 'nps'
                return (
                  <sky-feedback-dialog
                    feedback={feedback}
                    isModel={isModel}
                    sourceFrom={sourceFrom}
                    onCb={function() {
                      dialog.remove()
                      //如果有需要NPS采集，则先nps采集再下载
                      _this.download(item)
                    }}
                  />
                )
              },
              components: {
                FeedbackDialog
              },
              props: {
                title: title,
                width: '45%',
                showClose: false,
                showDefaultFooter: false,
                closeOnPressEscape: false
              }
            })
          } else {
            createNps({ toolId: item.id, npsStrategy: 'FIRST_USE' })
            _this.download(item)
          }
        })
      }
    },
    download(item) {
      if (item && item.provideMode === 'PROTECTION') {
        getToolUrl({ id: item.id })
          .then(response => {
            this.openUrl(response.data.content)
          })
          .catch(e => {
            throw e
          })
      } else {
        this.openUrl(item.toolUrl)
      }
    },
    fetchToolLogo(id, index) {
      if (id) {
        getToolLogo({ id: id })
          .then(response => {
            this.$set(this.toolInfo[index], 'logoBase64Data', response.data.content)
            this.$set(this.toolInfo[index], 'loadingEnd', true)
          })
          .catch(e => {
            throw e
          })
      }
    },
    handleClick() {
      if (this.activeName === 'all') {
        this.toolInfoItem = this.toolInfo
      } else {
        this.toolInfoItem = this.toolInfo.filter(one => one.toolCategory.indexOf(this.activeName) != -1)
      }
    },
    openUrl(url) {
      window.open(url, '_blank')
    },
    searchReq() {
      this.activeName = 'all'
      this.handleClick()
      if (this.searchKeyword) {
        this.toolInfoItem = this.toolInfo.filter(one => {
          return (
            (one.toolDesc && one.toolDesc.indexOf(this.searchKeyword) != -1) ||
            (one.toolScene && one.toolScene.indexOf(this.searchKeyword) != -1)
          )
        })
      } else {
        this.toolInfoItem = this.toolInfo
      }
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/mixin/mixin';
@import '~sky-engine/assets/styles/common/var.scss';
@include b(tool-list-page) {
  height: 888px;
  padding: 12px;
  padding-bottom: 24px;
  .tool-page-content {
    height: 100%;
    overflow-y: auto;
    position: relative;
    .tool-page-toolbar {
      position: absolute;
      width: 18%;
      right: 12px;
      z-index: 99;
    }
  }
  .tool-list-content {
    flex-wrap: wrap;
    padding: 0 64px;
    .tool-item {
      width: 24.5%;
      padding: 3px;
      position: relative;
      .tool-item-icon {
        width: 20%;
        padding: 0 3px;
      }
      .tool-item-description {
        width: 80%;
        padding: 0 12px;
      }
      .wsp-tool-dow-btn {
        position: absolute;
        bottom: 3px;
        right: 12px;
      }
    }
  }

  .wsp-tool-app-description-2-line-hidder {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    color: #5e5e5e;
  }

  .wsp-tool-app-description-1-line-hidder {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .card-content {
    display: flex;
  }

  .card-content-label {
    font-weight: bold;
    color: black;
  }
  .card-header {
    font-size: 18px;
    padding: 6px 0 6px 0px;
    font-weight: bold;
  }
  .card-text {
    font-size: 12px;
  }
  .el-card__body {
    padding: 8px 12px;
  }
  .el-card {
    width: 100%;
    height: 144px;
  }
}
</style>
<style></style>
